import { Outlet } from 'react-router-dom';
import { TopMenu } from '../../components/TopMenu';
import './Layout.scss';

export function Layout() {
  return (
    <>
      <TopMenu />
      <div style={{ paddingBottom: '60px' }}>
        <Outlet />
      </div>
    </>
  );
}
